import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../../../services/user.service';

@Component({
  selector: 'app-biometry-required',
  templateUrl: './biometry-required.component.html',
  styleUrls: ['./biometry-required.component.css']
})
export class BiometryRequiredComponent {
  growth: number;
  weight: number;
  clothingSize: number;
  shoeSize: number;
  saving = false;
  error = '';

  constructor(private userService: UserService,
              private route: ActivatedRoute,
              private router: Router) {
  }

  save(): void {
    this.error = '';
    if (!this.isValid()) {
      this.error = 'PLEASE_FILL_ALL_FIELDS';
      return;
    }
    this.saving = true;
    this.userService.saveMyBiometry(this.growth, this.weight, this.clothingSize, this.shoeSize)
      .subscribe(
        () => this.handleSaved(),
        () => {
          this.saving = false;
          this.error = 'CLOTHING_ERROR_DEFAULT';
        }
      );
  }

  private isValid(): boolean {
    return this.growth > 0
      && this.weight > 0
      && this.clothingSize > 0
      && this.shoeSize > 0;
  }

  private handleSaved(): void {
    const user = this.userService.getLocal();
    if (user) {
      user.biometryRequired = false;
      this.userService.setLocal(user);
    }
    const returnUrl = this.route.snapshot.queryParams['returnUrl'];
    this.router.navigateByUrl(returnUrl || '/dashboard');
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/biometry-required/biometry-required.component.ts